import React from 'react';
import { useTranslation } from 'react-i18next';

import { Paragraph } from '../components/Typography';

interface IProps {
  subscription: Subscription;
  response: string | null;
  showTitle?: boolean;
  isInDunning?: boolean;
  isFailed?: boolean;
  isPaymentMethodUpdated?: boolean;
}

export default ({
  subscription,
  response,
  showTitle,
  isInDunning = false,
  isFailed = false,
  isPaymentMethodUpdated = false,
}: IProps): React.ReactElement<IProps> => {
  const { t } = useTranslation();

  const paymentMethodType =
    subscription?.CustomerPaymentMethod?.instrument?.__typename;
  const cardType = subscription?.CustomerPaymentMethod?.instrument?.brand;
  const cardBrand =
    paymentMethodType === 'CustomerShopPayAgreement'
      ? 'Shop Pay'
      : `${cardType?.slice(0, 1).toUpperCase()}${cardType?.slice(1)}`;

  return (
    <>
      {showTitle && <h2>{t('subscription.payment_method')}</h2>}
      <div className="bundleapp-flex bundleapp-flex-align-start">
        <div className="bundleapp-flex-1">
          {paymentMethodType ? (
            <Paragraph
              modifiers={
                (isInDunning || isFailed) &&
                !response &&
                !isPaymentMethodUpdated
                  ? ['destructive']
                  : []
              }
            >
              {paymentMethodType === 'CustomerPaypalBillingAgreement' ? (
                t('subscription.pay_pal_payment_method')
              ) : (
                <>
                  {cardBrand} {t('subscription.ending_in')}{' '}
                  {subscription.CustomerPaymentMethod.instrument.lastDigits}
                  <br />
                  {t('subscription.expires')}{' '}
                  {subscription.CustomerPaymentMethod.instrument.expiryMonth}/
                  {subscription.CustomerPaymentMethod.instrument.expiryYear}
                </>
              )}
            </Paragraph>
          ) : null}
        </div>
      </div>
    </>
  );
};
